import {
  getDictionariesKnoSupervisionUuid,
  makeGetDictionariesSubjectTypesSelectOptions,
  makeGetDictionariesSubjectKindsSelectOptions,
  makeGetDictionariesSubjectSubKindsSelectOptions,
  makeGetDictionariesSupervisionTypesExtendedSelectOptions,
} from 'CorePackage/DictionariesModule/selectors/dictionariesSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getPlanDataKnoOrganizationDictVersionId } from 'PlanPackage/MainModule/selectors/planSelectors';

export const getKnmListByPlanPlanId = (state: IRootState) => state.knmListByPlan.planId;
export const getKnmListByPlanTypeList = (state: IRootState) => state.knmListByPlan.typeList;
export const getKnmListByPlanSearchValue = (state: IRootState) => state.knmListByPlan.searchValue;
export const getKnmListByPlanData = (state: IRootState) => state.knmListByPlan.data;
export const getKnmListByPlanOrder = (state: IRootState) => state.knmListByPlan.order;
export const getKnmListByPlanPage = (state: IRootState) => state.knmListByPlan.page;
export const getKnmListByPlanPageCount = (state: IRootState) => state.knmListByPlan.pageCount;
export const getKnmListByPlanTotalCount = (state: IRootState) => state.knmListByPlan.totalCount;
export const getKnmListByPlanCurrent = (state: IRootState) => state.knmListByPlan.current;
export const getKnmListByPlanCurrentId = (state: IRootState) => state.knmListByPlan.currentId;
export const getKnmListByPlanIsFilterOn = (state: IRootState) => state.knmListByPlan.isFilterOn;
export const getKnmListByPlanFilters = (state: IRootState) => state.knmListByPlan.filters;
export const getKnmListByPlanKnoOrganizationDictVersionId = (state: IRootState) =>
  getPlanDataKnoOrganizationDictVersionId(state);
export const getKnmListByPlanSupervisionTypeDictVersionId = (state: IRootState) =>
  state.knmListByPlan.supervisionTypeDictVersionId;
export const getKnmListByPlanKnoSupervisionUuid = (state: IRootState) => {
  const knoOrganizationDictVersionId = getKnmListByPlanKnoOrganizationDictVersionId(state);
  const supervisionTypeDictVersionId = getKnmListByPlanSupervisionTypeDictVersionId(state);

  if (knoOrganizationDictVersionId && supervisionTypeDictVersionId) {
    return getDictionariesKnoSupervisionUuid(state, knoOrganizationDictVersionId, supervisionTypeDictVersionId);
  }

  return undefined;
};
export const getKnmListByPlanSupervisionTypesSelectOptions = (state: IRootState) => {
  const getDictionariesSupervisionTypesSelectOptions = makeGetDictionariesSupervisionTypesExtendedSelectOptions();
  const knoOrganizationDictVersionId = getKnmListByPlanKnoOrganizationDictVersionId(state);

  if (knoOrganizationDictVersionId) {
    return getDictionariesSupervisionTypesSelectOptions(state, [knoOrganizationDictVersionId], false, true);
  }

  return undefined;
};
export const getKnmListByPlanSubjectTypesSelectOptions = (state: IRootState) => {
  const getDictionariesSubjectTypesSelectOptions = makeGetDictionariesSubjectTypesSelectOptions();
  const knoSupervisionUuid = getKnmListByPlanKnoSupervisionUuid(state);

  if (knoSupervisionUuid) {
    return getDictionariesSubjectTypesSelectOptions(state, knoSupervisionUuid, undefined);
  }

  return undefined;
};
export const getKnmListByPlanSubjectKindsSelectOptions = (state: IRootState) => {
  const getDictionariesSubjectKindsSelectOptions = makeGetDictionariesSubjectKindsSelectOptions();
  const knoSupervisionUuid = getKnmListByPlanKnoSupervisionUuid(state);

  if (knoSupervisionUuid) {
    return getDictionariesSubjectKindsSelectOptions(state, knoSupervisionUuid, undefined);
  }

  return undefined;
};
export const getKnmListByPlanSubjectSubKindsSelectOptions = (state: IRootState) => {
  const getDictionariesSubjectSubKindsSelectOptions = makeGetDictionariesSubjectSubKindsSelectOptions();
  const knoSupervisionUuid = getKnmListByPlanKnoSupervisionUuid(state);

  if (knoSupervisionUuid) {
    return getDictionariesSubjectSubKindsSelectOptions(state, knoSupervisionUuid, undefined);
  }

  return undefined;
};
